// 1. Core library imports
// import { createIcons, Bookmark, BookmarkCheck, FileSearchCorner } from 'lucide'
import { initMatomo } from '@certible/use-matomo'

// 2. CSS/Theme imports
// Webpack and css-loader process these files from the node_modules folder
//import 'instantsearch.css/themes/satellite-min.css'
import './classless.css'
import './themes.css'
import '@fontsource/libertinus-sans'
import './index.css'

// createIcons({
//   icons: {
//     FileSearchCorner,
//   },
// })
//
function play() {
  const actualPriceEur = parseFloat(document.getElementById('actualPrice').value)
  let exchangeRates = { USD: 1.09, GBP: 0.84 }

  const eurInput = document.getElementById('eurInput')
  const usdInput = document.getElementById('usdInput')
  const gbpInput = document.getElementById('gbpInput')
  const form = document.getElementById('gameForm')
  const pointsHiddenInput = document.getElementById('calculatedPoints')
  const mainImage = document.getElementById('mainImage')
  const thumbnails = document.querySelectorAll('.thumbnail')

  const modal = document.getElementById('resultModal')
  const nextBtn = document.getElementById('nextRoundBtn')

  const prevImageBtn = document.getElementById('prevImageBtn')
  const nextImageBtn = document.getElementById('nextImageBtn')

  let currentImageIndex = 0
  const totalImages = thumbnails.length

  function updateMainImage(index) {
    if (totalImages === 0 || !mainImage) return

    thumbnails.forEach((t) => t.classList.remove('active'))
    thumbnails[index].classList.add('active')
    mainImage.src = thumbnails[index].src
    currentImageIndex = index
  }

  if (prevImageBtn && nextImageBtn) {
    prevImageBtn.addEventListener('click', (e) => {
      e.preventDefault()
      let newIndex = currentImageIndex - 1
      if (newIndex < 0) newIndex = totalImages - 1
      updateMainImage(newIndex)
    })

    nextImageBtn.addEventListener('click', (e) => {
      e.preventDefault()
      let newIndex = currentImageIndex + 1
      if (newIndex >= totalImages) newIndex = 0
      updateMainImage(newIndex)
    })
  }

  thumbnails.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      updateMainImage(index)
    })
  })

  // thumbnails.forEach((thumb) => {
  //   thumb.addEventListener('click', () => {
  //     if (mainImage) {
  //       mainImage.src = thumb.src
  //     }
  //     thumbnails.forEach((t) => t.classList.remove('active'))
  //     thumb.classList.add('active')
  //   })
  // })

  const formatters = {
    de: new Intl.NumberFormat('de-DE', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }),
    us: new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }),
    uk: new Intl.NumberFormat('en-GB', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }),
  }

  let currentRawEur = 0

  fetch('https://open.er-api.com/v6/latest/EUR')
    .then((response) => response.json())
    .then((data) => {
      if (data && data.rates) {
        exchangeRates.USD = data.rates.USD || exchangeRates.USD
        exchangeRates.GBP = data.rates.GBP || exchangeRates.GBP
      }
    })
    .catch((err) => console.error('Exchange rate API unavailable, using fallbacks.', err))

  function parseLocaleValue(val, locale) {
    if (!val) return 0
    if (locale == 'de') {
      return parseFloat(val.replace(/\./g, '').replace(',', '.')) || 0
    } else {
      return parseFloat(val.replace(/,/g, '')) || 0
    }
  }

  function formatField(inputElement, value, locale) {
    if (!value || isNaN(value)) {
      inputElement.value = ''
      return
    }
    inputElement.value = formatters[locale].format(value)
  }

  function syncAllFields(source) {
    const rawUsd = Math.floor(currentRawEur * exchangeRates.USD)
    const rawGbp = Math.floor(currentRawEur * exchangeRates.GBP)

    if (source !== 'eur' && document.activeElement !== eurInput) formatField(eurInput, currentRawEur, 'de')
    if (source !== 'usd' && document.activeElement !== usdInput) formatField(usdInput, rawUsd, 'us')
    if (source !== 'gbp' && document.activeElement !== gbpInput) formatField(gbpInput, rawGbp, 'uk')
  }

  eurInput.addEventListener('input', () => {
    currentRawEur = parseLocaleValue(eurInput.value, 'de')
    syncAllFields('eur')
  })

  usdInput.addEventListener('input', () => {
    const rawUsd = parseLocaleValue(usdInput.value, 'us')
    currentRawEur = rawUsd / exchangeRates.USD
    syncAllFields('usd')
  })

  gbpInput.addEventListener('input', () => {
    const rawGbp = parseLocaleValue(gbpInput.value, 'uk')
    currentRawEur = rawGbp / exchangeRates.GBP
    syncAllFields('gbp')
  })
  ;[
    [eurInput, 'de', 'eur'],
    [usdInput, 'us', 'usd'],
    [gbpInput, 'uk', 'gbp'],
  ].forEach(([input, locale, key]) => {
    input.addEventListener('focus', () => {
      if (!currentRawEur) return
      let targetVal = currentRawEur
      if (key == 'usd') targetVal = Math.floor(currentRawEur * exchangeRates.USD)
      if (key == 'gbp') targetVal = Math.floor(currentRawEur * exchangeRates.GBP)

      input.value = locale == 'de' ? targetVal.toFixed(2).replace('.', ',').replace(',00', '') : targetVal.toFixed(2).replace('.00', '')
    })

    input.addEventListener('blur', () => {
      let targetVal = currentRawEur
      if (key == 'usd') targetVal = Math.floor(currentRawEur * exchangeRates.USD)
      if (key == 'gbp') targetVal = Math.floor(currentRawEur * exchangeRates.GBP)
      formatField(input, targetVal, locale)
    })
  })

  function spawnBalloons() {
    const colors = ['#e94560', '#0f0', '#00f0ff', '#ff00ff', '#ffff00']
    for (let i = 0; i < 20; i++) {
      const balloon = document.createElement('div')
      balloon.className = 'balloon'
      balloon.style.left = Math.random() * 100 + 'vw'
      balloon.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)]
      balloon.style.animationDuration = 3 + Math.random() * 2 + 's'
      balloon.style.animationDelay = Math.random() * 0.5 + 's'
      document.body.appendChild(balloon)

      setTimeout(() => balloon.remove(), 6000)
    }
  }

  form.addEventListener('submit', (e) => {
    e.preventDefault()
    if (isNaN(currentRawEur) || isNaN(actualPriceEur) || actualPriceEur <= 0) {
      pointsHiddenInput.value = 0
      return
    }

    const deviationPct = Math.abs(currentRawEur - actualPriceEur) / actualPriceEur
    const maxPoints = 5000
    let finalPoints = Math.round(maxPoints * (1 - deviationPct))

    if (finalPoints < 0) {
      finalPoints = 0
    }

    pointsHiddenInput.value = finalPoints
    eurInput.value = currentRawEur
    document.getElementById('modalGuess').innerText = formatters.de.format(currentRawEur) + ' €'
    document.getElementById('modalActual').innerText = formatters.de.format(actualPriceEur) + ' €'
    document.getElementById('modalPoints').innerText = `${finalPoints} (${Math.floor(deviationPct * 100)}% off)`
    modal.classList.add('active')

    if (finalPoints >= 3500) {
      spawnBalloons()
    }
  })
  nextBtn.addEventListener('click', () => {
    form.submit()
  })
}
window.play = play

const matomo = initMatomo({
  host: 'https://matomo.apps.markusko.ch',
  siteId: 3,
  trackRouter: true,
})
